'use strict';

module.exports = require('./Toggle');